






























import Vue from 'vue';
import { IMenuItem, IMobileNavigationComponent } from '@/common/interfaces/header.interface';
import MobileMenuBack from './MobileMenuBack.vue';
import MobileMenuEntry from './MobileMenuEntry.vue';
import MobileMenuParents from './MobileMenuParents.vue';

export default Vue.extend({
  name: `MobileNavigation`,
  components: { MobileMenuBack, MobileMenuEntry, MobileMenuParents },
  data(): IMobileNavigationComponent {
    return {
      selectedMenu: null,
      selectedTopic: null,
    };
  },
  computed: {
    mainMenu(): IMenuItem[] {
      if(this.selectedTopic !== null) {
        return [];
      }
      return this.topics;
    },
    subMenu(): IMenuItem[] | IMenuItem[][] {
      if(this.selectedMenu !== null) {
        return this.selectedMenu.children;
      }
      if(this.selectedTopic !== null) {
        const submenu = [];
        for(const group of this.selectedTopic.children) {
          for(const item of group) {
            submenu.push(item);
          }
        }
        return submenu;
      }
      return [];
    },
  },
  props: {
    topics: {
      required: true,
      type: Array as () => IMenuItem[],
    },
  },
  methods: {
    resetToParent(): void {
      if(this.selectedMenu !== null) {
        this.selectedMenu = null;
        return;
      }
      if(this.selectedTopic !== null) {
        this.selectedTopic = null;
        this.$emit(`changed:state`, false);
      }
    },
    selectMenu(item: IMenuItem): void {
      this.selectedMenu = item;
    },
    selectTopic(item: IMenuItem): void {
      this.selectedTopic = item;
      this.$emit(`changed:state`, true);
    },
  },
});
